<ng-container [formGroup]="formGroup()">
  @if (availableRegions() && availableRegions().length > 1) {
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Region</mat-label>
      <mat-select formControlName="region">
        @for (region of availableRegions(); track region.id) {
          <mat-option [value]="region.id">{{ region.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  @if (availableSubregionsToSelect().length > 0) {
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Subregion</mat-label>
      <mat-select formControlName="subregions" multiple>
        <mat-select-trigger>
          {{ selectedSubregionsLabel }}
        </mat-select-trigger>
        @for (subregion of availableSubregionsToSelect(); track subregion.id) {
          <mat-option [value]="subregion.id">{{ subregion.name }}</mat-option>
        }
      </mat-select>
      @if (formGroup().get('subregions')?.hasError('required')) {
        <mat-error>At least one subregion must be selected</mat-error>
      }
    </mat-form-field>
  }
</ng-container>
